module.exports = {
  name: "厦门特色中医药",
  orgCode: "0004",
  serviceUrl: "https://xy.gigtech.cn/service/", 
  postUrl: "/service/datahandler.ashx",   
};